/** @jsxImportSource @emotion/react */

import { FOOTER_LINKS } from "constants/footer";
import _map from "lodash/map";
import { Link } from "react-router-dom";

import { InfoBlockStyle } from "./index.style";

const InfoBlock = () => {
  return (
    <div css={InfoBlockStyle.self}>
      <h4>Thông tin</h4>
      <div css={InfoBlockStyle.infoList}>
        {_map(FOOTER_LINKS.infos, (item, index) => (
          <div key={index} css={InfoBlockStyle.infoItem}>
            <Link to={item.to} onClick={() => window.scrollTo({ top: 0 })}>
              {item.name as string}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfoBlock;
